import { render, staticRenderFns } from "./homeBanner.vue?vue&type=template&id=a639606e&scoped=true&"
import script from "./homeBanner.vue?vue&type=script&lang=js&"
export * from "./homeBanner.vue?vue&type=script&lang=js&"
import style0 from "./homeBanner.vue?vue&type=style&index=0&id=a639606e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a639606e",
  null
  
)

export default component.exports